export { ICacheOptions, Cache } from './cache';
